import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import { VcaAlarm } from './vca-alarm';
import { VcaAlarmsService } from './vca-alarms.service';
import { AlarmsNotifierService } from '../../app/services/alarm-notifier.service';
import { Alert } from '@clr/angular';
import { Subscription } from 'rxjs/Rx';

@Component({
    selector: 'vca-alarms',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./vca-alarms.scss')],
    template: `
    <div class="vca-alerts-module">
    <div class="vca-alerts" [class.vca-alerts-overlay]="alertOverlay" *ngFor="let alarm of alarms">
    <clr-alert *ngIf="showAlarmCheck(alarm)" (clrAlertClosedChange)="onClose(alarm)" [clrAlertClosable]="alertClosable" [clrAlertType]="'alert-info'" [clrAlertAppLevel]="alertAppLevel">
        <div  class="alert-item">
            <div class="alert-text">
                Info Alert: You have received a request for collection of tech support log bundles from the HCX admin.
            </div>
            <div class="alert-actions">
                <button class="btn btn-sm alert-action" (click)="askConfirmation(alarm,true)">Approve</button>
                <button class="btn btn-sm alert-action" (click)="askConfirmation(alarm,false)">Decline</button>
            </div>
        </div>
    </clr-alert>
    </div>
    </div>

    <div *ngIf="showConfirm">
    <clr-modal [(clrModalOpen)]="showConfirm" [clrModalSize]="'md'" [clrModalStaticBackdrop]="true">
    <h3 class="modal-title">{{confirmTitle}}</h3>
    <div class="modal-body">
    <p>{{confirmMsg}}</p>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn" (click)="showConfirm = false;">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="actionInProgress" (click)="ackAlarm()">
        <div *ngIf="actionInProgress" class="spinner spinner-sm spinner-inline">Loading...</div>
        Ok</button>
    </div>
    </clr-modal>
    </div>

    `
})

export class VcaAlarms {

    @Input() alertClosable: boolean = true;
    @Input() alertAppLevel: boolean = true;
    @Input() location: string = 'main_alarm';
    @Input() alertOverlay: boolean = true;


    private alarms: any;
    private alarmPollerSubscription: any;
    private closedAlarms: any = {};
    private subscription: Subscription;

    private showConfirm: boolean = false;
    private actionInProgress: boolean = false;
    private confirmTitle: string;
    private confirmMsg: string;
    private confirmData: any = {};

    constructor(private alarmsNotifierService: AlarmsNotifierService, private alarmsService: VcaAlarmsService, private router: Router ) {
        this.alarmPollerSubscription = this.alarmsNotifierService.getAlarms().subscribe(
            alarms => {
                this.handleAlarms(alarms);
            }, error => {},
            () => {}
        );
    }

    private handleAlarms(alarms) {
        this.alarms = alarms;
    }

    private showAlarmCheck(alarm) {
        if ( alarm && ( (this.closedAlarms && this.closedAlarms[alarm.jobId] == true) || (Object.keys(alarm).length < 1 || !alarm.jobId) ) ) {
            return false;
        } else {
            return true;
        }
    }

    private onClose(alarm) {
        if (alarm && alarm.jobId) {
            this.closedAlarms[alarm.jobId] = true;
        }
    }

    reviewAlarms(alarm: any) { // todo : remove
        if (alarm && alarm.jobId) {
            this.closedAlarms[alarm.jobId] = true;
            this.router.navigate(['/administration/troubleshooting']);
        }
    }

    askConfirmation(alarm: any, approved: boolean) {
        if (alarm && approved === true) {
            this.confirmTitle = 'Approve Tech Support Bundle Request';
            this.confirmMsg = `Are you sure you want to approve the request for tech support log bundles.` ;
        } else if (alarm) {
            this.confirmTitle = 'Decline Tech Support Bundle Request';
            this.confirmMsg = `Are you sure you want to decline the request for tech support log bundles.` ;
        }
        this.confirmData["alarm"] = alarm;
        this.confirmData["approved"] = approved;
        this.showConfirm = true;
    }

    private ackAlarm() {
        let alarm = (this.confirmData && this.confirmData.alarm) ? this.confirmData.alarm : {};
        let approved = (this.confirmData && this.confirmData.approved) ? this.confirmData.approved : false;
        if (alarm && alarm.jobId) {
            this.actionInProgress = true;
            let payload = {"jobId": alarm.jobId, "hasApproved" : (approved ? true : false)};
            this.subscription = this.alarmsService.acknowledgeAlarm(payload).subscribe(
            res => {
                this.closedAlarms[alarm.jobId] = true;
                this.logOperationCompleted('AckAlarm operation success');
            },
            error => {
                this.closedAlarms[alarm.jobId] = true;
                this.logOperationCompleted('AckAlarm operation failed');
            },
            () => {
                this.closedAlarms[alarm.jobId] = true;
                this.logOperationCompleted('AckAlarm completed');
            }
            );
        }
    }

    private logOperationCompleted(msg: string) {
        this.actionInProgress = false;
        this.showConfirm = false;
        console.log("logOperationCompleted", msg);
    }

}



// WEBPACK FOOTER //
// ./src/common/vca-alarms/vca-alarm.component.ts